import { createStyles, Theme } from '@material-ui/core';

export const styles = ({ spacing }: Theme) =>
  createStyles({
    paperComponent: {
      padding: spacing(0),
    },
  });
